//enablex
const path = require('path');

const that = {};

const getBrowserInfo = () => {
  let version = 'none';
  let name;
  let verOffset;
  const userAgent = window.navigator.userAgent;

  if ((verOffset = userAgent.indexOf('OPR')) != -1) {
    name = 'opera';
  } else if ((verOffset = userAgent.indexOf('Firefox')) != -1) {
    name = 'mozilla';
  } else if ((verOffset = userAgent.indexOf('Edg')) != -1) {
    name = 'edge';
  } else if ((verOffset = userAgent.indexOf('Chrome')) != -1) {
    name = 'chrome-stable';
  } else if ((verOffset = userAgent.indexOf('Safari')) != -1) {
    name = 'safari';
    if ((verOffset = userAgent.indexOf('Version')) != -1) {
      version = userAgent.substring(verOffset + 8);
    }
  } else if (((verOffset = userAgent.indexOf('MSIE')) != -1) || ((verOffset = userAgent.indexOf('Windows NT')) != -1)) {
    name = 'IE';
  } else {
    name = 'none';
  }

  if (version == 'none' && verOffset != -1) {
    const verStr = userAgent.substring(verOffset);
    if ((verOffset = verStr.indexOf('/')) != -1) {
      version = verStr.substring(verOffset + 1);
    }
  }

  let tempVersion;
  if ((tempVersion = version.indexOf(';')) != -1) {
    version = version.substring(0, tempVersion);
  }
  if ((tempVersion = version.indexOf(' ')) != -1) {
    version = version.substring(0, tempVersion);
  }
  const type = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(userAgent) ?
    'mobile' : 'desktop';
  return {
    name,
    version,
    device_type: type,
  };
};

that.browser_info = getBrowserInfo();

that.is_supported = !!(((RTCPeerConnection !== undefined) && (/chrome-stable|mozilla|safari|opera|edge/i.test(that.browser_info.name))));

that.browser_type = (window.navigator.userAgent.match('Chrome') ? 'chrome-stable' :
  window.navigator.userAgent.match('Firefox') ? 'mozilla' :
    window.navigator.userAgent.match(/Safari|AppleWebKit/g) ? 'safari' :
      window.navigator.userAgent.match('Edge') ? 'edge' :
        window.navigator.userAgent.match('Electron') ? 'electron' :
          window.navigator.userAgent.match('.NET') ? 'IE' : 'none');

that.device_type =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(window.navigator.userAgent) ?
    'mobile' : 'desktop';

that.videoBitrateQualityMap;

that.cameraResolutionTable;

module.exports = {
  product: {
    company: 'Vcloudx Inc', //Compny name
    product: 'enablex.io', //Product name
    version: '2.0.0', // version
    release: '2.0.0', //release
  },
  default_region: ['IN'],
  data_throughput_duration: 2, // in seconds
  video_bandwidth_duration: 10, // in seconds
  audio_bandwidth_duration: 10, // in seconds
  video_layer_bitrates: {
    0: 300000,
    1: 800000,
    2: 1500000,
  },
  video_resolution_range: {
    HD: { min: { width: 320, height: 180 }, max: { width: 1280, height: 720 } },
    SD: { min: { width: 320, height: 180 }, max: { width: 960, height: 540 } },
    LD: { min: { width: 80, height: 45 }, max: { width: 640, height: 360 } },
  },
  video_bandwidth_range: {
    HD: { 0: { min: 100, max: 1200 }, 1: { min: 100, max: 800 }, 2: { min: 100, max: 400 } },
    SD: { 0: { min: 100, max: 700 }, 1: { min: 100, max: 400 }, 2: { min: 100, max: 250 } },
    LD: { 0: { min: 80, max: 400 }, 1: { min: 80, max: 250 }, 2: { min: 80, max: 150 } },
    ND: { 0: { min: 0, max: 0 }, 1: { min: 40, max: 200 }, 2: { min: 40, max: 100 } },
    share: { min: 100, max: 400 },
    canvas: { min: 1024, max: 4096 },
  },
  
  screen_resolution_range: {
    HD: {bw:600, fps:20},
    SD: {bw:400, fps:15},
    LD: {bw:200, fps:10}
  },

  proxy_api_url: 'apiproxy.enablex.io',
  proxy_api_port: 443,
  ice_servers: {
    IN: {
          turnURI: 'turns:ts.enablex.io:443',
          turnUsername: 'vcxturn',
          turnCredential: 'V201301',
          stunURI: 'stun:stun.l.google.com:19302',
        },
    US: {
        turnURI: 'turns:eu2ts.enablex.io:443',
        turnUsername: 'vcxturn',
        turnCredential: 'V201301',
        stunURI: 'stun:stun.l.google.com:19302',
        },
    SG: {
        turnURI: 'turns:sgts.enablex.io:443',
        turnUsername: 'vcxturn',
        turnCredential: 'V201301',
        stunURI: 'stun:stun.l.google.com:19302',
        },
    DE: {
        turnURI: 'turns:gwcts.enablex.io:443',
        turnUsername: 'vcxturn',
        turnCredential: 'V201301',
        stunURI: 'stun:stun.l.google.com:19302',
        },
  },
  browser_info: that.browser_info,
  browser_type: that.browser_type,
  device_type: that.device_type,
  user_agent: window.navigator.userAgent,
  is_supported: () => that.is_supported,
  setVideoBwQualityMapper: (videoBitrateQualityMap) => {
    if (videoBitrateQualityMap.minBwKbpsToCheck) {
      that.videoBitrateQualityMap = videoBitrateQualityMap.bpsQualityMapTable.slice();
      that.cameraResolutionTable = videoBitrateQualityMap.camResTable.slice();
    }
    that.videoQualityMapMinBwKbps = videoBitrateQualityMap.minBwKbpsToCheck;
  },
  getBitrateMapTable: () => that.videoBitrateQualityMap,
  getCamResolutionTable: () => that.cameraResolutionTable,
  getCamResTableToCheck: (kbps) => {
    if (that.videoBitrateQualityMap !== undefined && (kbps <= that.videoQualityMapMinBwKbps)) {
      for (let i = 0; i < that.videoBitrateQualityMap.length; i++) {
        if (that.videoBitrateQualityMap[i].kbps <= kbps) {
          return {
            resTable: that.cameraResolutionTable.slice(that.videoBitrateQualityMap[i].resTable.index),
            fps: that.videoBitrateQualityMap[i].fps.max,
          };
        }
      }
    }
  },
  internetDetectionUrl: 'https://api.enablex.io/status',
};



//////////////////
// WEBPACK FOOTER
// ./Common.config.js
// module id = 4
// module chunks = 0